enum terriEnum {
deleteconfirmationMessage='Do you want to delete this Territory?',
commentconfirmationMessage='Do you want to delete this Comment?',
clearRulesMessage='Are you sure want to clear added rules?',
rulesClearConfirmation='Clear added Rules?',
list='list',
view ='View',
edit ='Edit',
delete='Delete',
split='split',
new ='New',
newIcon ='pi pi-plus',
setting='Settings',
assign='Assign permission',
data="Assign data",
settingIcon='pi pi-cog ',
listIcon='pi pi-list',
userIcon= 'pi pi-user',
deleteHeader='Delete Confirmation',
editIcon='pi pi-pencil',
viewIcon='pi pi-eye',
deleteIcon='pi pi-trash',
deleteCircleIcon='pi pi-info-circle',
rotateIcon='fa fa-thumb-tack fa-rotate-90',

territoryAssignSuccessMsg='Territory Permission Assigned successfully...',
success='Success',
error='Error',
errorMsg='Error occurred while saving data...',
territorySaveSuccessMsg='Territory saved successfully...',

createterritory='createTerritory2',
createActivity='createActivity',
editTerritory='Edit Territory',
territoryEditSuccessMsg='Territory updated successfully...',
territoryCommentSuccessMsg='Territory Comments Updated successfully...',
territoryDeleteSuccessMsg='Territory Deleted successfully...',
territoryDeleteErrorMsg='Error occurred while deleting  data...',
territoryCommentDeletedSuccessMSg='Territory Comments Deleted  successfully...',
contactDeletesucessMsg='Territory User Deleted successfully...',
viewTerritory="View Territory",
addTerritory="Add New Territory",
deleteContactConfirmationMsg='Do you want to delete this Contact?',
defaultFilter='allterritorys',
norecordsFound='No Records Found.',
rolename='administrator',
rootTerritory='Root',
active='Active',
primaryUser='Primary User',
secondaryUser='Secondary User',
territoryNameRequired='Territory Name Is Required',
ErrorTerritoryComment='Comment is Required',
moduleName='Territory',
mapurl='https://maps.googleapis.com/maps/api/geocode/json?address=',
mapkey='AIzaSyDe4eFGUfn88nHM6fDkRt_vk-vEfEohWHU',
country='country',
state='state',
city='city',
}
export{

    terriEnum
}
